module.exports = __webpack_public_path__ + "static/media/canvas-studio-media@1x.8c318e38.png";